import { useEffect } from 'react'
// import mapboxgl from 'mapbox-gl'

/**
 * adiciona marker da posição do user
 */
function MapUserLocation({ mapRef: { current }, userCoordinates }) {
  useEffect(() => {
    const source = current.map.getSource('user')
    if (userCoordinates && userCoordinates.lng && userCoordinates.lat) {
      const coordinates = [userCoordinates.lng, userCoordinates.lat - 0.001]

      const userPoints = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates,
            },
            properties: {
              icon: 'user-location',
            },
          },
        ],
      }

      if (source) {
        // update
        source.setData(userPoints)
      } else {
        current.map.addSource('user', {
          type: 'geojson',
          data: userPoints,
        })

        current.map.addLayer({
          id: 'user',
          type: 'symbol',
          source: 'user',
          layout: {
            'icon-image': '{icon}',
            'icon-allow-overlap': true,
            'icon-size': 0.15,
          },
        })
      }

      setTimeout(
        () =>
          current.map.easeTo({
            center: coordinates,
            zoom: 14,
            // pitch: 30,
          }),
        500,
      )
    }
  }, [userCoordinates])

  return null
}

export default MapUserLocation
